import React,{useRef, useState, useEffect} from "react";
import { Form, Col, Row, Button} from "react-bootstrap";
import Select from "react-select";
import EditableRange from "../components/EditableRange";
import vindrApi from "../utils/vindrapi";
import { X, Trash, Angle, Subtract} from "@phosphor-icons/react";
import ColorPicker			from "../components/ColorPicker";
import LayerExclusion		from "../classes/LayerExclusion";


const types = [
	{label: 'Wetlands', value:1},
	{label: 'Terrain', value:2},
	{label: 'Lakes', value:3}
];

export default function ExclusionExtractPanel({
	setup,
	handler,
	onClose,
	onChange,
	onOpacityChange,
	onColorChange,
	onSaveClose,
	onSaveSettings
		
}) {


	const [type,setType]	= useState(0);
	const [slope,setSlope]	= useState(0);
	const [buffer,setBuffer]	= useState(0);
	
	const defaultColor = LayerExclusion.defaultColor;
	
	const makeData = () =>{
		return {type, slope, buffer};
	}
	
	const handleClose = () => {
		
		if(onClose)
			onClose(makeData());
	}
	const handleSaveClose = () => {
		
		if(onSaveClose)
			onSaveClose(makeData());
	}
	const handleSaveCloseSettings = () => {
		if(onSaveSettings)
			onSaveSettings();
	}
	
	const handleSlopeChange = (e) => {
		setSlope(e.target.value);
		if(onChange)
			onChange({type:type.value, slope:e.target.value, buffer:buffer});
	}
	const handleBufferChange = (e) => {
		setBuffer(e.target.value);
		
		if(onChange)
			onChange({type:type.value, slope, buffer:e.target.value});
	}
	const handleOpacityChange = (e) =>{
		if(onOpacityChange)
			onOpacityChange(parseInt(e.target.value));
	}
	const handleColorChange = (color) =>{
		if(onColorChange)
			onColorChange(color);
	}
	
	const handleTypeChange = (val) => {
		
		setType(val);
		if(onChange)
			onChange({type:val.value, slope, buffer});
	}
	
	return (
		<div className="powerroads-panel power-roads" >
	
			{!!handler.exclusionId &&
			<Row>
				<Col xs="12 title pb-2">
					<b>{setup.obj.properties.name}</b>
					<span onClick={handleClose} className="btn btn-close btn-sm float-end"><X size={12} /></span>
				</Col>
				<Col xs="12 my-4">
					<label>Color</label>
					<ColorPicker onChange={handleColorChange} color={setup.obj.properties.color ?? defaultColor} />
				</Col>
				<Col xs="12 mb-5">
					<label>Opacity (%)</label>
					<EditableRange min="1" max="100" step="1" value={setup.obj.properties.opacity ?? 100} onChange={handleOpacityChange} />
				</Col>
				
				<Col xs="12">
					<Button variant="primary" onClick={handleSaveCloseSettings}>Save & close</Button>
				</Col>
			</Row>
			}
			{!handler.exclusionId &&
			<Row>
				<Col xs="12 title pb-2">
					<b>Extract exclusion zone</b>
					<span onClick={handleClose} className="btn btn-close btn-sm float-end"><X size={12} /></span>
				</Col>
				<Col xs="12 my-3">
					<label>Type of exclusion</label>
					<Select className="react-select-container" classNamePrefix="react-select" placeholder="Select type" onChange={handleTypeChange} isClearable={false} options={types} />
				</Col>
				{type.value == 2 && 
				<Col xs="12 mb-3">
					<label><Angle size={16} weight="bold" /> Slope in terrain (%)</label>
					<EditableRange min="1" max="100" step="1" value={slope} onChange={handleSlopeChange} />
				</Col>
				}
				{!!type &&
				<Col xs="12 mb-5">
					<label><Subtract size={16} weight="bold" /> Outer buffer (m)</label>
					<EditableRange min="1" max="10" step="1" value={buffer} onChange={handleBufferChange} />
				</Col>
				}
				<Col xs="12">
					<Button variant="primary" onClick={handleSaveClose}>Extract from selection</Button>
				</Col>
			</Row>
			}
		</div>	  
	);
	

}
